import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { PosthogService } from '@core/services/posthog.service';

@Directive({
  selector: '[dataTrack]'
})
export class PostHogDataTrackDirective {

  @Input('dataTrack') eventId!: string;

  constructor(private el: ElementRef, private postHogService: PosthogService) {}

  @HostListener('click')
  onClick() {
    if(!this.eventId) return;

    if(this.el.nativeElement.tagName == 'BUTTON' || this.el.nativeElement.tagName == 'A' || this.el.nativeElement.tagName == 'MAT-SLIDE-TOGGLE'){
        var baseProps = {
        id: this.eventId,
        name: this.el.nativeElement.name || null,
        text: (this.el.nativeElement.innerText || "").replace(/\s+/g, " ").substring(0, 100),
        tag: (this.el.nativeElement.tagName || "").toLowerCase(),
        href: this.el.nativeElement.href || null
        };
        this.postHogService.trackPostHogEvent('click', baseProps);
    }
  }

  @HostListener('selectionChange', ['$event'])
  onSelectionChange(event: any) {
    if(!this.eventId) return;

    if (this.el.nativeElement.tagName === 'MAT-SELECT') {
      const baseProps = {
        id: this.eventId,
        name: this.el.nativeElement.getAttribute('name') || null,
        value: event.value
      };

      this.postHogService.trackPostHogEvent('DropDown Change', baseProps);
    }
  }

  @HostListener('blur')
  onBlur() {
    if(!this.eventId) return;

    if(this.el.nativeElement.tagName == 'INPUT' || this.el.nativeElement.tagName == 'TEXTAREA'){
        var baseProps = {
        id: this.eventId,
        name: this.el.nativeElement.name || null,
        value: this.el.nativeElement.value
        };
        this.postHogService.trackPostHogEvent('Text Input Change', baseProps);
    }
  }
}
